const wsk = {
  page404: {
    title: "Zřejmě jste se ztratili",
    message: "Ztratili jste se?",
    action_btn: "Zpět na úvod"
  },
  address: {
    title: "Address",
    type: {
      personal: "Soukromá osoba",
      company: "Firma"
    },
    organisation: {
      label: "Název firmy"
    },
    name: {
      first_name: "Jméno",
      last_name: "Příjmení",
      label: "Jméno"
    },
    contact_person: {
      first_name: "Jméno",
      last_name: "Příjmení",
      label: "Kontaktní osoba"
    },
    street: {
      label: "Ulice a číslo",
      address1: "Address 1",
      address2: "Address 2"
    },
    city: {
      label: "Město"
    },
    postal_code: {
      label: "PSČ"
    },
    country_code: {
      label: "Země"
    },
    company_data: {
      title: "Firemní údaje"
    },
    company_id: {
      label: "IČO"
    },
    tax_id: {
      label: "DIČ"
    },
    vat_id: {
      label: "IČ DPH"
    }
  },
  empty_state: {
    title: "Nothing to show here..."
  },
  profile: {
    emails: {
      label: "Email (můžete zadat více emailů)"
    },
    email: {
      label: "Email"
    },
    phone: {
      label: "Telefon",
      short: "Phone"
    }
  },
  validation: {
    country_required: "Vyplňte zemi",
    company_id: {
      not_valid: "Neplatné IČO"
    },
    tax_id: {
      not_valid: "Neplatné DIČ"
    },
    vat_id: {
      not_valid: "Neplatné IČ DPH"
    }
  },
  general: {
    back: "Zpět",
    cancel: "Zrušit",
    close: "Zavřít",
    remove: "Odstranit",
    optional: "nepovinné",
    period: {
      months_one: "{count} měsíc",
      years_one: "{count} rok",
      months_few: "{count} měsíce",
      years_few: "{count} roky",
      months_other: "{count} měsíců",
      years_other: "{count} roků",
      explicit: "Období",
      short: {
        months: "{period, plural, one {# měsíc} few {# měsíce} other {# měsíců}}",
        years_one: "{count} rok",
        years_few: "{count} roky",
        years_other: "{count} roků"
      },
      next: {
        months_one: "příští měsíc",
        years_one: "příští rok",
        months_few: "příští {count} měsíce",
        years_few: "příští {count} roky",
        months_other: "příštích {count} měsíců",
        years_other: "příštích {count} roků",
        short: {
          months_one: "příští měs.",
          years_one: "příští rok",
          months_few: "příští {count}měs.",
          years_few: "příští {count}roky",
          months_other: "příštích {count}měs.",
          years_other: "příštích {count}roků"
        }
      },
      per: {
        months_one: "měsíčně",
        years_one: "ročně",
        months_few: "na {count} měsíce",
        years_few: "na {count} roky",
        months_other: "na {count} měsíců",
        years_other: "na {count} roků",
        short: {
          months_one: "/měs",
          years_one: "/rok",
          months_few: "/{count}měs.",
          years_few: "/{count}roky",
          months_other: "/{count}měs.",
          years_other: "/{count}roků"
        }
      }
    },
    or: "nebo",
    recommended: "doporučeno",
    settings: "Nastavení",
    edit: "Upravit",
    save: "Uložit",
    save_changes: "Uložit",
    reset_form: "vymazat formulář",
    not_available: "Nedostupné",
    unknown_error: "Neznámá chyba",
    unknown_error_id: "Neznámá chyba ({id})",
    something_went_wrong: "Omlouváme se za neočekávaný výsledek. Něco se pokazilo.",
    link: "odkaz",
    buy: "Koupit"
  },
  capslock_hint: {
    line1: "Caps Lock",
    line2: "je zapnutý"
  },
  ws_password_input: {
    expose_password: "Zobrazit heslo"
  },
  ws_array_input: {
    incorrect_email: "Nesprávná email adresa (adresy)",
    incorrect_web: "Nesprávná webová adresa (adresy)",
    some_filtered: "Tento řetězec není možné zpracovat."
  },
  ws_places_input: {
    no_results: "Hledané místo nebylo nalezeno. Zkuste méně specifickou adresu"
  },
  ws_uploader: {
    validation: {
      file_type: "Nesprávný typ souboru.",
      file_size: "Velikost souboru překračuje limit ({limit})"
    },
    status: {
      label: "Stav",
      value: {
        uploaded: "nahrané",
        uploading: "Nahrávám",
        failed: "selhání",
        idle: "idle"
      }
    },
    action: {
      title: "Nahrané faktury",
      text1: "Přesuňte soubor nebo",
      link: "vyberte",
      text2: ".",
      abort_tooltip: "Zrušit nahrávání"
    },
    supported_file_types: "Podporované typy souborů:",
    remove_btn: "Odstranit"
  },
  ws_table: {
    filter: {
      fulltext_title: "Fulltextové vyhledávání",
      data_title: "Vyhledávání",
      clear_filters: "Vymazat všechny filtry",
      from: "Od",
      to: "Do"
    },
    label: {
      bulk_actions: "Hromadná akce",
      cancel_selection: "Zrušit výběr",
      item_selected: "vybrané položky",
      selected: "Vybraný",
      filterby: "Filtrovat podle",
      records_per_page: "Položek na stránce:",
      select_all: "Vybrat vše"
    }
  },
  ws_password_strength: {
    rule1: "Minimálně 8 znaků",
    rule2: "Minimálně 1 velké a 1 malé písmeno",
    rule3: "Minimálně 1 číslo",
    rule4: "Minimálně  1 speciální znak"
  },
  ws_password_confirmation_input: {
    passwords_do_not_match: "Hesla se neshodují!"
  },
  ws_two_factor_authentication_input: {
    on_cooldown_one: "Kód můžete znovu odeslat za {count} sekundu.",
    on_cooldown_few: "Kód můžete znovu odeslat za {count} sekund.",
    on_cooldown_other: "Kód můžete znovu odeslat za {count} sekund.",
    resend_code: "Znovu odeslat kód",
    code_being_sent: "Odesílání 2FA kódu...",
    code_sent_successfully: "2FA kód byl úspěšně odeslán",
    error_sending_code: "Chyba při odesílání 2FA kódu",
    invalid_code_pasted: "Vložili jste neplatný kód 2FA. Zadejte prosím platný kód 2FA."
  },
  generate_random: "Generuj náhodné",
  copy: {
    copy: "Kopírovat",
    copied: "Zkopírováno",
    saved_in_clipboard: "Zkopírováno"
  },
  out_modal: {
    title: "Váš prohlížeč není aktuální",
    text: "Aktualizujte si prosím váš prohlížeč nebo zkuste nainstalovat jiný.",
    delimiter_text: "Můžeme pomoci"
  },
  buttons: {
    ok_thanks: "Ok, Thanks"
  },
  payment_cards: {
    ending_with: "Ending with",
    active: "Active",
    issued_by: "Vydavatel karty: {issuer}."
  },
  ws_sub_items_price_summary: {
    current_price: "Cena za službu (aktuální fakturační období)",
    due_now: "Splatné ihned",
    next_period_subtraction_warning: "* Cena bude odečtena v následujícím fakturačním období",
    next_price: "Cena za službu (následující fakturační období)"
  },
  dialog_footer: {
    cannot_submit_empty_form: "It is not possible to submit an empty form."
  },
  price_badge: {
    including_vat: "(s DPH)",
    excluding_vat: "(bez DPH)"
  },
  cart_item: {
    notices: {
      business_mail: {
        license_count_increase: {
          title: "Vaše doména již má aktivní e-mailové schránky.",
          text_one: "Aktuálně máte {count} e-mailovú schránku na této doméně. Pro migraci na Business Mail je třeba do objednávky přidat minimálně rovnaký počet Premium licencí",
          text_few: "Aktuálně máte {count} e-mailové schránky na této doméně. Pro migraci na Business Mail je třeba do objednávky přidat minimálně rovnaký počet Premium licencí.",
          text_other: "Aktuálně máte {count} e-mailových schránek na této doméně. Pro migraci na Business Mail je třeba do objednávky přidat minimálně rovnaký počet Premium licencí."
        },
        free_trial: {
          title: "60-denní Free trial",
          text: "Pro každou službu Business Mail je automaticky aktivována bezplatná zkušební verze, v jejímž rámci můžete otestovat nejvyšší licenci Premium."
        },
        free_trial_postfix: {
          title: "60-denní Free trial",
          text_one: "Pro všechny vaše hostingové e-mailové schránky, které přemigrujeme, se automaticky aktivuje bezplatná zkušební verze, v jejímž rámci můžete otestovat nejvyšší licenci Premium. Pro její využití je třeba do objednávky přidat minimálně takový počet Premium licencí, kolik e-mailových schránek se migruje (Máte 1 e-mailovou schránku). <b>Migrace může ovlivnit obsah schránky (kontakty/kalendáře) proto před objednávkou doporučujeme si prostudovat <a href='https://www.websupport.cz/podpora/kb/automaticka-migrace-z-e-mailu-u-hostingu-na-sluzbu-business-mail/' target='_blank'>jak funguje proces migrace na Business Mail</a></b>.",
          text_few: "Pro všechny vaše hostingové e-mailové schránky, které přemigrujeme, se automaticky aktivuje bezplatná zkušební verze, v jejímž rámci můžete otestovat nejvyšší licenci Premium. Pro její využití je třeba do objednávky přidat minimálně takový počet Premium licencí, kolik e-mailových schránek se migruje (Máte {count} e-mailové schránky). <b>Migrace může ovlivnit obsah schránky (kontakty/kalendáře) proto před objednávkou doporučujeme si prostudovat <a href='https://www.websupport.cz/podpora/kb/automaticka-migrace-z-e-mailu-u-hostingu-na-sluzbu-business-mail/' target='_blank'>jak funguje proces migrace na Business Mail</a></b>.",
          text_other: "Pro všechny vaše hostingové e-mailové schránky, které přemigrujeme, se automaticky aktivuje bezplatná zkušební verze, v jejímž rámci můžete otestovat nejvyšší licenci Premium. Pro její využití je třeba do objednávky přidat minimálně takový počet Premium licencí, kolik e-mailových schránek se migruje (Máte {count} e-mailových schránek). <b>Migrace může ovlivnit obsah schránky (kontakty/kalendáře) proto před objednávkou doporučujeme si prostudovat <a href='https://www.websupport.cz/podpora/kb/automaticka-migrace-z-e-mailu-u-hostingu-na-sluzbu-business-mail/' target='_blank'>jak funguje proces migrace na Business Mail</a></b>."
        },
        free_trial_premium_licenses_notice: {
          title_one: "Pro migraci na Business Mail potřebujete minimálně 1 Premium licenci",
          title_few: "Pro migraci na Business Mail potřebujete minimálně {count} Premium licence",
          title_other: "Pro migraci na Business Mail potřebujete minimálně {count} Premium licencí",
          text: "V zájmu jednoduchosti jsme vám potřebný počet Premium licencí automaticky přidali (pokud jste tak sami neučinili v předchozím kroku).<b>Migrace se může promítnout do obsahu schránky (kontakty/kalendáře), proto před objednávkou doporučujeme prostudovat,<a href='https://www.example.com' target='_blank'>jak celý proces migrace na Business Mail funguje</a>.</b>"
        }
      }
    }
  },
  login_pages: {
    footer: {
      help: "Pomoc",
      terms: "Podmínky",
      privacy: "Soukromí"
    },
    help: {
      title: "Potřebujete poradit?",
      text: "Vždy můžete navštívit naši <a href='{kb_url}' target='_blank'>znalostní bázi </a> nebo kontaktovat naši <a href='{support_url}' target='_blank'>zákaznickou podporu</a>."
    }
  },
  message_service: {
    error: {
      axios: {
        title: "Network Error",
        text: "Unable to connect"
      },
      status_401: {
        text: "You don't have the required permissions."
      },
      status_403: {
        text: "Access denied."
      },
      status_404: {
        text: "Source not found."
      },
      status_407: {
        text: "Please login via the Legacy Active24 login page."
      },
      status_408: {
        text: "Connection timeout."
      },
      status_500: {
        text: "Uh oh, something went wrong. Please contact our support."
      },
      unexpected: {
        title: "Error",
        text: "Unexpected error"
      }
    }
  },
  ws_input: {
    invalid_phone_number: "Invalid phone number",
    phone_missing: "Phone is required"
  },
  ws_google_autocomplete: {
    no_results: "Hledané místo nebylo nalezeno. Zkuste méně specifickou adresu"
  }
};
const wsk_csCZ = {
  wsk
};
export {
  wsk_csCZ as default,
  wsk
};
//# sourceMappingURL=wsk.cs-CZ.json.es.js.map
